import React, { createContext, useState, useMemo, useContext } from 'react';

const LoaderContext = createContext(null);
const getLastKey = (q) => {
    return Array.from(q).pop();
};
const keyGenerator = (q) => {
    var _a;
    const lastKeyIndex = (_a = getLastKey(q)) === null || _a === void 0 ? void 0 : _a.replace("loader-", "");
    return `loader-${Number(lastKeyIndex || 0) + 1}`;
};
// TODO remove logic for random key generation
function LoaderProvider({ children }) {
    const [queue, setQueue] = useState(new Set());
    const enqueueLoader = (loaderKey) => {
        setQueue((prevQueue) => {
            const key = loaderKey || keyGenerator(prevQueue);
            return new Set(prevQueue).add(key);
        });
    };
    const dequeueLoader = (loaderKey) => {
        setQueue((prevQueue) => {
            if (prevQueue.size <= 1)
                return new Set();
            const newQueue = new Set(prevQueue);
            const key = loaderKey || getLastKey(prevQueue);
            newQueue.delete(key);
            return newQueue;
        });
    };
    const setLoader = (isLoading, loadingKey) => {
        isLoading ? enqueueLoader(loadingKey) : dequeueLoader(loadingKey);
    };
    const loader = useMemo(() => queue.size > 0, [queue]);
    return React.createElement(LoaderContext.Provider, { value: { loader, setLoader, queue } }, children);
}
function useLoader() {
    return useContext(LoaderContext);
}

export { LoaderProvider, useLoader };
